import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontWeight, Fonts, Spacing } from "@snapchat/snap-design-system";

const { Paragraph, Heading } = Fonts;

export const headerCss = css`
    display: flex;
    gap: ${Spacing["1XS"]}px;
    align-items: center;

    font-size: ${Paragraph.P100};
    font-weight: ${FontWeight.MEDIUM};
    color: ${Colors.Black.V200};
`;

export const subSectionCss = css`
    display: flex;
    flex: 50%;
    flex-direction: column;
    gap: 5px;
`;

export const headingCss = css`
    ${Heading.H400}
`;

export const DaysNumberTag = styled.span<{ withinDaysThreshold: boolean }>`
    padding: 3px 10px;
    background-color: ${(props) => {
        return props.withinDaysThreshold ? Colors.Yellow.V200 : Colors.Red.V10;
    }};
    border-radius: 10%;
`;

export const DaysLeftText = styled.div<{ withinDaysThreshold: boolean }>`
    ${Paragraph.P300};
    font-weight: ${FontWeight.MEDIUM};
    color: ${(props) => {
        if (props.withinDaysThreshold) {
            return Colors.Black.V200;
        }
        return Colors.Red.V150;
    }};
`;

export const PostersNumberTag = styled.span<{ reachedUniquePosters: boolean }>`
    padding: 3px 10px;
    background-color: ${(props) => {
        return props.reachedUniquePosters ? Colors.Green.V10 : Colors.Yellow.V200;
    }};
    border-radius: 10%;
`;

export const PostersText = styled.div<{ color: string }>`
    ${Paragraph.P300};
    font-weight: ${FontWeight.MEDIUM};
    color: ${(props) => props.color};
`;
